import defaultThemeOptions from "./default";

const themeOptions = defaultThemeOptions;

export { themeOptions, defaultThemeOptions };
export const FontLoader = () => null;
